import React from "react";
import { Modal } from "../../ui/Modal";
import { Button } from "../../ui/Button";

interface RestoreConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const RestoreConfirmModal: React.FC<RestoreConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Restore"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Restore
          </Button>
        </>
      }
    >
      <p className="text-gray-600">
        Are you sure you want to restore this backup? This will replace all
        current data and reload the application.
      </p>
    </Modal>
  );
};
